import { useState, useEffect, useRef } from "react";
import { getSupabase } from "@dwelldrop/supabase";
import { CATEGORIES } from "@dwelldrop/shared";

export interface CategoryRow {
  key: string;
  label: string;
  icon: string;
  color: string;
  bg_color: string;
}

/** Fetch active categories from DB with fallback to hardcoded constants */
export function useCategories(): {
  categories: CategoryRow[];
  loading: boolean;
} {
  const [categories, setCategories] = useState<CategoryRow[]>(
    CATEGORIES.map((c) => ({
      key: c.key,
      label: c.label,
      icon: c.icon,
      color: c.color,
      bg_color: c.bgColor,
    })),
  );
  const [loading, setLoading] = useState(true);
  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;

    async function load() {
      try {
        const supabase = getSupabase();
        const { data, error } = await supabase
          .from("categories")
          .select("key, label, icon, color, bg_color")
          .eq("is_active", true)
          .is("deleted_at", null)
          .order("sort_order", { ascending: true });

        if (!error && data && data.length > 0) {
          setCategories(data as CategoryRow[]);
        }
      } catch {
        // keep fallback
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  return { categories, loading };
}
